import { render, staticRenderFns } from "./Flipper.vue?vue&type=template&id=6f127015&"
import script from "./Flipper.vue?vue&type=script&lang=js&"
export * from "./Flipper.vue?vue&type=script&lang=js&"
import style0 from "./Flipper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports